import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Progress, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, Accordion, AccordionItem, Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import "moment-timezone";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone, forEach } from "lodash";
import Select from "react-select";
import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";
import { api } from "../../../config";
import ModalImage from "react-modal-image";
import classnames from "classnames";
import Flatpickr from "react-flatpickr";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetCivilBudgetControlState, getCivilBudgetControl as onGetCivilBudgetControls, addNewCivilBudgetControl as onAddNewCivilBudgetControl, updateCivilBudgetControl as onUpdateCivilBudgetControl, deleteCivilBudgetControl as onDeleteCivilBudgetControl, getCivilBudgetControlLoading } from "../../../store/civilBudgetControl/action";
import { resetCivilBudgetState, getCivilBudget as onGetCivilBudgets } from "../../../store/civilBudget/action";
import "react-toastify/dist/ReactToastify.css";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import SimpleBar from "simplebar-react";
import ExportDoc from "../../../Components/Common/ExportDoc";

const CivilBudget = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, civilBudgets, loading, error, civilBudgetControls, civilBudgetControlLoading, isCivilBudgetControlCreated, isCivilBudgetControlSuccess } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    civilBudgets: state.CivilBudget.civilBudgets,
    loading: state.CivilBudget.loading,
    error: state.CivilBudget.error,
    civilBudgetControls: state.CivilBudgetControl.civilBudgetControls,
    civilBudgetControlLoading: state.CivilBudgetControl.loading,
    isCivilBudgetControlCreated: state.CivilBudgetControl.isCivilBudgetControlCreated,
    isCivilBudgetControlSuccess: state.CivilBudgetControl.isCivilBudgetControlSuccess,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [civilBudgetSelectList, setCivilBudgetSelectList] = useState([]);
  const [componentControlAddedId, setComponentControlAddedId] = useState(0);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [civilBudgetControl, setCivilBudgetControl] = useState([]);
  const [label, setLabel] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState("");
  const [modalMaterial, setModalMaterial] = useState(false);

  const [budgetName, setBudgetName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [filterDate, setFilterDate] = useState();
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [unit, setUnit] = useState(1);
  const [totalAll, setTotalAll] = useState(0);
  const [totalHrg, setTotalHrg] = useState(0);
  const [totalReal, setTotalReal] = useState(0);
  const [totalRealPaid, setTotalRealPaid] = useState(0);
  const [totalRealPayable, setTotalRealPayable] = useState(0);
  const [totalAllPayable, setTotalAllPayable] = useState(0);
  const [totalQty, setTotalQty] = useState(0);
  const [totalRealQty, setTotalRealQty] = useState(0);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const expanseDataRef = useRef([]);
  const [expense, setExpense] = useState([]);
  const [accTrans, setAccTrans] = useState([]);
  const [info, setInfo] = useState([]);
  const [controlDetail, setControlDetail] = useState([]);
  const [dataPrintDoc, setDataPrintDoc] = useState([]);
  const [printDetailDoc, setPrintDetailDoc] = useState([]);

  useEffect(() => {
    if (companySelected && branchSelected) {
      dispatch(resetCivilBudgetControlState());
      dispatch(resetCivilBudgetState());
      dispatch(onGetCivilBudgets({ companyId: companySelected.value, branchId: branchSelected.value }));
    }
  }, [companySelected, branchSelected]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      setIsEdit(false);
    }
  }, [civilBudgets, componentControlAddedId]);

  useEffect(() => {
    var data = [];
    var opt = [];
    civilBudgets.forEach((item, key) => {
      if (item.type === "INFRASTRUKTUR" || item.type === "BANGUNAN" || item.type === "PEKERJAAN TAMBAH 1" || item.type === "PEKERJAAN TAMBAH 2" || item.type === "PEKERJAAN TAMBAH 3" || item.type === "PEKERJAAN TAMBAH 4" || item.type === "PEKERJAAN TAMBAH 5" || item.type === "PEKERJAAN TAMBAH 6" || item.type === "PEKERJAAN TAMBAH 7" || item.type === "PEKERJAAN TAMBAH 8" || item.type === "LISTRIK JARINGAN") {
        const name = item.cvl_branch ? item.cvl_branch.name + " - " + item.name : item.name;
        const id = item.id;
        var obj = { label: name, value: id, data: item };
        opt.push(obj);
      }
    });
    var option = { options: opt };
    data.push(option);
    setCivilBudgetSelectList(data);
  }, [civilBudgets]);

  useEffect(() => {
    if (!isEmpty(civilBudgetControls)) {
      setCivilBudgetControl(civilBudgetControls);
      let ttlAll = 0;
      let ttlHrg = 0;
      let ttlReal = 0;
      let ttlRealPaid = 0;
      let ttlRealPayable = 0;
      let ttlAllPayable = 0;
      let ttlQty = 0;
      let ttlRealQty = 0;
      const sortAccount = civilBudgetControls.sort((a, b) => a.sort_order_account - b.sort_order_account);
      let arrCat = [];
      for (const data of sortAccount) {
        let findCategory = arrCat.find((x) => x.title === data.name);
        if (!findCategory) arrCat.push({ title: data.name });

        if (data.material_name) {
          let qty = data.quantity > 0 ? data.quantity : 1;
          ttlHrg += parseFloat(data.amount);
          ttlQty += parseFloat(qty);
          ttlAll += parseFloat(qty) * parseFloat(data.amount);

          let total_realization_payable = data.realization.filter((item) => item.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount - (v.paid_amount || 0))), 0);
          let total_realization_all_payable = data.realization.filter((item) => item.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount)), 0);
          let total_realization_paid = data.realization.filter((item) => item.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount)), 0);
          let total_realization = total_realization_paid + total_realization_payable;
          ttlReal += parseFloat(total_realization);
          ttlRealPaid += parseFloat(total_realization_paid);
          ttlRealPayable += parseFloat(total_realization_payable);
          ttlAllPayable += parseFloat(total_realization_all_payable);
        }
      }

      setTotalAll(ttlAll);
      setTotalHrg(ttlHrg);
      setTotalReal(ttlReal);
      setTotalRealPaid(ttlRealPaid);
      setTotalRealPayable(ttlRealPayable);
      setTotalAllPayable(ttlAllPayable);

      let arrFin = [];
      for (const cat of arrCat) {
        let arr = [];
        for (const data of sortAccount) {
          const materialName = data?.material_name ?? "-";
          if (data.name === cat.title) arr.push({ ...data, isSelected: true, material_name: materialName });
        }
        arrFin.push({ id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`, title: cat.title, isSelected: true, data: arr });
      }

      setControlDetail(arrFin);
    } else {
      setControlDetail([]);
    }
  }, [civilBudgetControls, civilBudgetControlLoading]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleMaterial = useCallback(() => {
    if (modalMaterial) {
      setModalMaterial(false);
    } else {
      setModalMaterial(true);
    }
  }, [modalMaterial]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setAccTrans(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCivilBudgetControl(element.value));
    });
    checkall.checked = false;
  };

  function currencyFormat(num) {
    return parseFloat(Math.round(num)).toLocaleString(["ban", "id"]);
  }

  useEffect(() => {
    const dataDoc = [
      { id: "material_name", label: "URAIAN PEKERJAAN", isSelected: true, data: [] },
      { id: "sub_total", label: "SUBTOTAL", isSelected: true, data: [] },
      { id: "unit", label: "UNIT", isSelected: true, data: [] },
      { id: "total", label: "TOTAL", isSelected: true, data: [] },
      { id: "total_realization_paid", label: "TERBAYAR", isSelected: true, data: [] },
      { id: "total_realization_payable", label: "SISA HUTANG", isSelected: true, data: [] },
      { id: "total_realization", label: "REALISASI", isSelected: true, data: [] },
      { id: "realization", label: "SISA ANGGARAN", isSelected: true, data: [] },
    ];

    if (controlDetail?.length > 0) {
      controlDetail.forEach((row) => {
        if (!row.isSelected) return;
        if (!Array.isArray(row.data) || row.data.length === 0) return;

        const dataValid = row.data[0];
        const qty = dataValid.quantity > 0 ? dataValid.quantity : 1;
        const amount = parseFloat(dataValid.amount ?? 0);

        const totalRealizationPaid = (dataValid.realization || []).filter((item) => item.type === "CASH OUT").reduce((a, v) => a + parseFloat(v.amount), 0);
        const totalRealizationPayable = (dataValid.realization || []).filter((item) => item.type === "PAYABLE").reduce((a, v) => a + parseFloat(v.amount - (v.paid_amount || 0)), 0);
        const totalRealization = totalRealizationPaid + totalRealizationPayable;
        const realization = amount * qty * unit - totalRealization;

        dataDoc.find((d) => d.id === "material_name")?.data.push(dataValid.material_name ?? "-");
        dataDoc.find((d) => d.id === "sub_total")?.data.push(currencyFormat(amount * qty));
        dataDoc.find((d) => d.id === "unit")?.data.push(unit === 1 ? "LS" : unit);
        dataDoc.find((d) => d.id === "total")?.data.push(currencyFormat(amount * qty * unit));
        dataDoc.find((d) => d.id === "total_realization_paid")?.data.push(currencyFormat(totalRealizationPaid));
        dataDoc.find((d) => d.id === "total_realization_payable")?.data.push(currencyFormat(totalRealizationPayable));
        dataDoc.find((d) => d.id === "total_realization")?.data.push(currencyFormat(totalRealization));
        dataDoc.find((d) => d.id === "realization")?.data.push(currencyFormat(realization));
      });
    }

    setDataPrintDoc(dataDoc);
  }, [controlDetail, unit]);

  useEffect(() => {
    let dataDoc = [
      // {
      //   id: "name",
      //   label: "Jenis Transaksi",
      //   isSelected: true,
      //   data: [],
      // },
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Harga Beli",
        isSelected: true,
        data: [],
      },
      {
        id: "quantity",
        label: "Qty",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Total",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "transactionat") {
                doc.data.push(handleValidDate(value));
              } else if (doc.id === "amount") {
                doc.data.push(currencyFormat(parseFloat(value || 0) || 0));
              } else {
                doc.data.push(value ?? "-");
              }
            } else {
              // const nameTrans = dataDoc.find((d) => d.id === "name");
              // nameTrans.data.push(data.name ?? "-");
            }
          });
        }
      });
    }

    setPrintDetailDoc(dataDoc);
  }, [expense]);

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter(
        (el) => (el?.at_purchase?.purchase_detail || []).some(function (item) {
          return (item.name ?? "").toLowerCase().includes(query.toLowerCase()) || (item.cvl_account ?? "").toLowerCase().includes(query.toLowerCase()) || (item?.purchase_cvl_budget?.type ?? "").includes(query.toLowerCase())
        }) ||
          (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || "").toLowerCase().includes(query.toLowerCase()) || el.amount.toString().toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.description ?? "").toString().toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.transaction_no ?? "").toString().toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.type ?? "").toString().toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          handleValidDate(el.transactionat).toString().toLowerCase().indexOf(query.toLowerCase()) !== -1,
      );
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  const toggleActiveAccordion = (el) => {
    if (el !== activeAccordion) setActiveAccordion(el);
    else setActiveAccordion("");
  };

  const sumRealization = (element) => {
    let total = 0;
    for (const el of element) total += el.realization.reduce((a, v) => (a = a + parseFloat(v.accepted || 0) * parseFloat(v.amount)), 0);
    return total;
  };

  const sumRestRealization = (element) => {
    let total = 0;
    for (const el of element) {
      let total_realization = el.realization.reduce((a, v) => (a = a + parseFloat(v.accepted || 0) * parseFloat(v.amount)), 0);
      total += el.price * el.quantity * unit - total_realization;
    }
    return currencyFormat(total);
  };

  document.title = "Cost Control Global | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Teknik" pageTitle="Cost Control Global" loading={loading || civilBudgetControlLoading} />
        <Row>
          <Col sm={12}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <div className="mb-1 flex-grow-1">
                  {budgetName ? (
                    <h3 className="mb-1 text-uppercase text-success">{budgetName}</h3>
                  ) : (
                    <h5 className="text-uppercase">
                      Pengawasan Biaya &nbsp;
                      {civilBudgetControlLoading && (
                        <>
                          <Spinner color="primary" type="grow" size={"sm"}>
                            Loading...
                          </Spinner>
                          &nbsp;
                          <Spinner color="success" type="grow" size={"sm"}>
                            Loading...
                          </Spinner>
                          &nbsp;
                        </>
                      )}
                    </h5>
                  )}

                  <p className="mb-1 fs-14 fw-semibold text-uppercase">{branchName}</p>
                  <p className="mb-1 fs-14 fw-semibold text-uppercase">JUMLAH {unit} UNIT</p>
                </div>
                <div className="flex-shrink-0">
                  <div
                    className="mb-3 d-flex"
                    style={{
                      position: "relative",
                      width: "680px",
                      zIndex: 1000,
                    }}
                  >
                    <div className="search-box me-2 mb-3">
                      <Flatpickr
                        className="form-control"
                        id="datepicker-publish-input"
                        placeholder="Pilih Tanggal"
                        value={filterDate}
                        options={{
                          mode: "range",
                          dateFormat: "Y/m/d",
                        }}
                        onChange={(selectedDates, dateStr) => {
                          setFilterDate(dateStr);
                        }}
                      />
                      <i className="bx bx-calendar-alt search-icon"></i>
                    </div>
                    <div className="flex-grow me-2" style={{ width: "360px" }}>
                      <Select
                        name="branch"
                        className="text-uppercase w-100"
                        placeholder=" Pilih Aggaran Proyek"
                        style={{ position: "absolute" }}
                        onChange={(e) => {
                          setBranchName(e.data.cvl_branch.name);
                          setUnit(parseInt(e.data.unit));
                          setBudgetName(e.data.name);
                          dispatch(resetCivilBudgetControlState());
                          if (filterDate) {
                            let datearr = filterDate?.split(" to ");
                            if (datearr) dispatch(onGetCivilBudgetControls({ civilBudgetId: e.data.id, startat: datearr[0], endat: datearr[1] ? datearr[1] : datearr[0] }));
                          } else dispatch(onGetCivilBudgetControls({ civilBudgetId: e.data.id }));
                        }}
                        options={civilBudgetSelectList}
                      ></Select>
                    </div>
                    {controlDetail.length > 0 && (
                      <div className="flex-shrink-0">
                        <ExportDoc data={dataPrintDoc} />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="card-body pt-0 ps-3 pe-3 pb-0">
                {controlDetail.length > 0 && (
                  <>
                    <div className="hstack border-bottom" style={{ width: "100%" }}>
                      <div className="" style={{ width: "28%" }}>
                        <div className="p-3 pt-1">URAIAN PEKERJAAN</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1">SUBTOTAL</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1">TOTAL</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1">TERBAYAR</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1">SISA HUTANG</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1">REALISASI</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1">SISA ANGGARAN</div>
                      </div>
                    </div>
                    <SimpleBar className="mb-3" style={{ height: "550px" }}>
                      {(controlDetail || []).map((element, index) => {
                        return (
                          <Fragment key={index}>
                            {(element.data || [])
                              .sort((a, b) => (a.material_name ? a.material_name > b.material_name : -1))
                              .map((el, idx) => {
                                let qty = el.quantity > 0 ? el.quantity : 1;
                                let total_realization_paid = el.realization.filter((item) => item.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount)), 0);
                                let total_realization_payable = el.realization.filter((item) => item.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount - (v.paid_amount || 0))), 0);
                                let total_realization = total_realization_paid + total_realization_payable;
                                let realization = el.amount * qty * unit - total_realization;
                                return (
                                  <Accordion className="p-0 border-0 lefticon-accordion custom-accordionwithicon" key={idx}>
                                    <AccordionItem className="border-0">
                                      <div
                                        className={classnames("accordion-button p-0 m-0 ps-3", { collapsed: activeAccordion === `${idx}-${index}` ? false : true })}
                                        onClick={() => {
                                          toggleActiveAccordion(`${idx}-${index}`);
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <div className="hstack" style={{ width: "100%" }}>
                                          <div className="border-bottom fw-semibold" style={{ width: "28%" }}>
                                            <div className="p-2">{el.material_name}</div>
                                          </div>
                                          <div className="text-end border-bottom" style={{ width: "12%" }}>
                                            <div className="p-2">{currencyFormat(parseFloat(qty) * parseFloat(el.amount))}</div>
                                          </div>
                                          <div className="text-end border-bottom" style={{ width: "12%" }}>
                                            <div className="p-2">{currencyFormat(parseFloat(qty) * parseFloat(el.amount) * unit)}</div>
                                          </div>
                                          <div className="text-end border-bottom" style={{ width: "12%" }}>
                                            <div className="p-2">
                                              <em
                                                className="fw-semibold text-info"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                  expanseDataRef.current = el.realization;
                                                  setInfo(el);
                                                  setExpense(el.realization);
                                                  toggle();
                                                }}
                                              >
                                                {currencyFormat(total_realization_paid)}
                                              </em>
                                            </div>
                                          </div>
                                          <div className="text-end border-bottom" style={{ width: "12%" }}>
                                            <div className="p-2">
                                              <em
                                                className="fw-semibold text-danger"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                  expanseDataRef.current = el.realization;
                                                  setInfo(el);
                                                  setExpense(el.realization);
                                                  toggle();
                                                }}
                                              >
                                                {currencyFormat(total_realization_payable)}
                                              </em>
                                            </div>
                                          </div>
                                          <div className="text-end border-bottom" style={{ width: "12%" }}>
                                            <div className="p-2">
                                              <em
                                                className="fw-semibold text-primary"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                  expanseDataRef.current = el.realization;
                                                  setInfo(el);
                                                  setExpense(el.realization);
                                                  toggle();
                                                }}
                                              >
                                                {currencyFormat(total_realization)}
                                              </em>
                                            </div>
                                          </div>
                                          <div className={realization < 1 ? "text-end bg-soft-danger border-opacity-25 border-danger fw-semibold text-danger" : "text-end bg-soft-success border-bottom border-success border-opacity-25 text-success fw-semibold"} style={{ width: "12%" }}>
                                            <div className="p-2">{currencyFormat(realization)}</div>
                                          </div>
                                        </div>
                                      </div>

                                      <Collapse isOpen={activeAccordion === `${idx}-${index}` ? true : false} className="accordion-collapse border-0">
                                        <div className="accordion-body p-0">
                                          <p className={el.realizationMaterial.length > 0 ? "d-none" : "text-warning text-center m-0 p-3 bg-soft-warning"}>TIDAK ADA KEBUTUHAN MATERIAL PADA ANGGARAN INI</p>
                                          <table className={el.realizationMaterial.length > 0 ? "table-border text-center table-hover table-nowrap align-middle" : "d-none"} style={{ width: "100%" }}>
                                            <thead>
                                              <tr className="bg-white">
                                                <th scope="col" className="p-2 text-start bg-light ps-3">
                                                  {" "}
                                                  MATERIAL
                                                </th>
                                                <th scope="col" className="p-2 text-center bg-light">
                                                  VOL
                                                </th>
                                                <th scope="col" className="p-2 text-center bg-light">
                                                  SATUAN
                                                </th>
                                                <th scope="col" className="p-2 text-end bg-light pe-1">
                                                  HARGA
                                                </th>
                                                <th scope="col" className="p-2 text-end text-white bg-info">
                                                  HARGA RAB
                                                </th>
                                                <th scope="col" className="p-2 text-end text-white bg-info d-none">
                                                  REALISASI PESANAN
                                                </th>
                                                <th scope="col" className="p-2 text-end text-white bg-info">
                                                  REALISASI
                                                </th>
                                                <th scope="col" className="p-2 text-end text-white bg-info">
                                                  SELISIH
                                                </th>
                                                <th scope="col" className="p-2 text-end text-white bg-primary">
                                                  VOL RAB
                                                </th>
                                                <th scope="col" className="p-2 text-end text-white bg-primary">
                                                  PESANAN
                                                </th>
                                                <th scope="col" className="p-2 text-end text-white bg-primary">
                                                  TERIMA
                                                </th>
                                                {/* <th scope="col" className="p-2 text-end text-white bg-primary" style={{ width: "80px" }}>
                                                  STOK
                                                </th> */}
                                                <th scope="col" className="p-2 text-end text-white bg-primary" style={{ width: "80px" }}>
                                                  SELISIH
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {(el.realizationMaterial || [])
                                                .sort((a, b) => a?.name?.localeCompare(b?.name, undefined, { numeric: true, sensitivity: "base" }))
                                                .map((ele, idx) => {
                                                  let total_realization = ele.realization.reduce((a, v) => (a = a + parseFloat(v.accepted || 0) * parseFloat(v.amount)), 0);
                                                  let total_realization_qty = ele.realization.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
                                                  let total_realization_acc = ele.realization.reduce((a, v) => (a = a + parseFloat(v.accepted || 0)), 0);
                                                  let realization = ele.price * ele.quantity * unit - total_realization;
                                                  let realization_qty = ele.quantity * unit - ele.realization.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
                                                  let total_realization_accepted = ele.realization.reduce((a, v) => (a = a + parseFloat(v.accepted || 0) * parseFloat(v.amount)), 0);

                                                  return (
                                                    <tr key={idx} className="pb-4">
                                                      <td className="p-2 ps-3 bg-light text-start text-dark border-bottom">{ele.name}</td>
                                                      <td className="p-2 bg-light text-center text-dark fw-semibold border-bottom">{parseFloat(ele.quantity)}</td>
                                                      <td className="p-2 bg-light text-center text-dark border-bottom">{ele.uom}</td>
                                                      <td className="p-2 bg-light text-end pe-2 text-dark border-bottom">{currencyFormat(ele.price || 0)}</td>
                                                      <td className="p-2 text-end fw-semibold bg-soft-info border-bottom border-opacity-25 border-info text-dark">{currencyFormat(parseFloat(ele.quantity) * parseFloat(ele.price) * unit)}</td>
                                                      <td className="p-2 text-end text-info bg-soft-info fw-semibold border-opacity-25 border-info d-none text-dark">
                                                        <em
                                                          className="fw-semibold text-info"
                                                          style={{ cursor: "pointer" }}
                                                          onClick={() => {
                                                            expanseDataRef.current = ele.realization;
                                                            setLabel(ele.name);
                                                            setExpense(ele.realization);
                                                            toggleMaterial();
                                                          }}>
                                                          {currencyFormat(total_realization || 0)}
                                                        </em>
                                                      </td>
                                                      <td className="p-2 text-end text-info bg-soft-info fw-semibold border-bottom border-opacity-25 border-info">
                                                        <em
                                                          className="fw-semibold text-info"
                                                          style={{ cursor: "pointer" }}
                                                          onClick={() => {
                                                            expanseDataRef.current = ele.realization;
                                                            setLabel(ele.name);
                                                            setExpense(ele.realization);
                                                            toggleMaterial();
                                                          }}
                                                        >
                                                          {currencyFormat(total_realization_accepted || 0)}
                                                        </em>
                                                      </td>
                                                      <td className={realization < 1 ? "p-2 text-end border-bottom border-opacity-25 border-danger bg-soft-danger text-info fw-semibold text-danger" : "p-2 text-end border-bottom border-success border-opacity-25 bg-soft-success text-success fw-semibold"}>{currencyFormat(realization || 0)}</td>
                                                      <td className="p-2 text-end text-dark fw-semibold bg-soft-primary border-bottom border-opacity-25 border-primary">{currencyFormat(parseFloat(ele.quantity) * unit)}</td>
                                                      <td className="p-2 text-end text-info bg-soft-primary border-bottom border-opacity-25 border-primary">
                                                        <em
                                                          className="fw-semibold text-info"
                                                          style={{ cursor: "pointer" }}
                                                          onClick={() => {
                                                            expanseDataRef.current = ele.realization;
                                                            setLabel(ele.name);
                                                            setExpense(ele.realization);
                                                            toggleMaterial();
                                                          }}
                                                        >
                                                          {parseFloat(total_realization_qty).toFixed(2).replace(".", ",")}
                                                        </em>
                                                      </td>
                                                      <td className="p-2 text-end text-info bg-soft-primary border-bottom border-opacity-25 border-primary">
                                                        <em
                                                          className="fw-semibold text-info"
                                                          style={{ cursor: "pointer" }}
                                                          onClick={() => {
                                                            expanseDataRef.current = ele.realization;
                                                            setLabel(ele.name);
                                                            setExpense(ele.realization);
                                                            toggleMaterial();
                                                          }}
                                                        >
                                                          {parseFloat(total_realization_acc).toFixed(2).replace(".", ",")}
                                                        </em>
                                                      </td>
                                                      {/* <td className={"p-2 text-end text-dark fw-semibold bg-soft-primary border-bottom border-opacity-25 border-primary"}>
                                                        {parseFloat(ele.stock || 0)
                                                          .toFixed(2)
                                                          .replace(".", ",")}
                                                      </td> */}
                                                      <td className={realization_qty < 1 ? "p-2 text-end border-bottom border-opacity-25 border-danger bg-soft-danger text-info fw-semibold text-danger" : "p-2 text-end border-bottom border-success border-opacity-25 bg-soft-success text-success fw-semibold"}>{currencyFormat(realization_qty || 0)}</td>
                                                    </tr>
                                                  );
                                                })}
                                            </tbody>
                                            <tfoot>
                                              <tr>
                                                <th colSpan={4} className="p-2 text-end text-dark border-bottom bg-light">
                                                  TOTAL
                                                </th>
                                                <td className="p-2 text-end fw-semibold pe-2 text-dark border-bottom bg-light">{currencyFormat(el.realizationMaterial.reduce((a, v) => (a = a + parseFloat(v.quantity) * parseFloat(v.price) * unit), 0))}</td>
                                                <td className="p-2 text-end fw-semibold pe-2 text-info border-bottom bg-light">{currencyFormat(sumRealization(el.realizationMaterial))}</td>
                                                <td className="p-2 text-end fw-semibold pe-2 border-bottom bg-light">
                                                  <span className={parseFloat(sumRestRealization(el.realizationMaterial)) < 1 ? "text-danger" : "text-success"}>{sumRestRealization(el.realizationMaterial)}</span>
                                                </td>
                                                <td colSpan={6} className={sumRealization(el.realizationMaterial) > total_realization ? "bg-soft-danger border-bottom border-opacity-25 border-danger" : "border-bottom bg-light"}>
                                                  {sumRealization(el.realizationMaterial) > total_realization ? <span className="text-danger fw-semibold">Selisih catatan pembelian dan keuangan Rp. {currencyFormat(sumRealization(el.realizationMaterial) - total_realization)}</span> : ""}
                                                </td>
                                              </tr>
                                            </tfoot>
                                          </table>
                                        </div>
                                      </Collapse>
                                    </AccordionItem>
                                  </Accordion>
                                );
                              })}
                          </Fragment>
                        );
                      })}
                    </SimpleBar>
                    <div className="hstack border-bottom fw-semibold" style={{ width: "100%" }}>
                      <div className="" style={{ width: "28%" }}>
                        <div className="p-3 pt-1">TOTAL</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">{currencyFormat(totalAll)}</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">{currencyFormat(totalAll * unit)}</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">{currencyFormat(totalRealPaid)}</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">{currencyFormat(totalRealPayable)}</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">{currencyFormat(totalReal)}</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">{currencyFormat(totalAll * unit - totalReal)}</div>
                      </div>
                    </div>
                    <div className="hstack border-bottom fw-semibold" style={{ width: "100%" }}>
                      <div className="" style={{ width: "28%" }}>
                        <div className="p-3 pt-1">&nbsp;</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">&nbsp;</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">&nbsp;</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">TOTAL HUTANG</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">{currencyFormat(totalAllPayable)}</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">&nbsp;</div>
                      </div>
                      <div className="text-end" style={{ width: "12%" }}>
                        <div className="p-3 pt-1 pe-2">&nbsp;</div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </Card>
          </Col>
        </Row>
        <Modal id="showModal" isOpen={modal} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggle}>
            {info.material_name}
          </ModalHeader>
          <ModalBody>
            <CardBody>
              <div>
                <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                  <div className="col-sm-10">
                    <Row className="m-0 p-0 ">
                      <div className="fw-semibold  text-start">
                        <input className="search-box  w-100 form-control" placeholder="Filter Transaksi" onChange={(e) => searchList(e.target.value)} />
                      </div>
                    </Row>
                  </div>
                  <div className="col-sm-2 text-end">
                    <ExportDoc data={printDetailDoc} />
                  </div>
                </Row>
                <SimpleBar style={{ height: "450px" }}>
                  <Table className="table-border text-center table-hover">
                    <thead className="align-middle">
                      <tr className="table-active">
                        <td style={{ width: "20px" }}>
                          <input
                            type="checkbox"
                            className="checkboxDetailAll me-2 form-check-input"
                            checked={expense.every((item) => item.isChecked)}
                            onChange={() => {
                              const allChecked = expense.every((item) => item.isChecked);
                              const updatedData = expense.map((item) => ({
                                ...item,
                                isChecked: !allChecked,
                              }));
                              setExpense(updatedData);
                            }}
                          />
                        </td>
                        <td className="text-center" style={{ width: "100px" }}>
                          No Transaksi
                        </td>
                        <td className="text-center" style={{ width: "80px" }}>
                          Tanggal
                        </td>
                        <td className="text-center" style={{ width: "80px" }}>
                          Jenis
                        </td>
                        <td className="text-right" style={{ width: "170px" }}>
                          Tag
                        </td>
                        <td className="text-right" style={{ width: "170px" }}>
                          Jumlah
                        </td>
                        <td className="text-right" style={{ width: "170px" }}>
                          Terbayar
                        </td>
                        <td className="text-center" style={{ width: "200px" }}>
                          Keterangan
                        </td>
                      </tr>
                    </thead>
                    <tbody id="newlink">
                      {(expense || [])
                        .sort((a, b) => new Date(a.transactionat) - new Date(b.transactionat))
                        .map((o, i) => {
                          let type;
                          switch (o.type) {
                            case "CASH IN":
                              type = <span className="badge text-uppercase badge-soft-success">{o.type}</span>;
                              break;
                            case "RECEIVABLE":
                              type = <span className="badge text-uppercase badge-soft-info">{o.type}</span>;
                              break;
                            case "CASH OUT":
                              type = <span className="badge text-uppercase badge-soft-warning">{o.type}</span>;
                              break;
                            case "PAYABLE":
                              type = <span className="badge text-uppercase badge-soft-danger">{o.type}</span>;
                              break;
                            default:
                              type = <span className="badge text-uppercase badge-soft-primary">{o.type}</span>;
                              break;
                          }
                          return (
                            <tr key={i} className={(o.hasPaid || o.paid_amount >= o.amount) ? "bg-soft-success" : o.statusId === 4 ? "bg-soft-danger" : ""}>
                              <td style={{ verticalAlign: "middle", width: "30px" }}>
                                <div className="hstack gap-2 mt-4 mt-sm-0">
                                  <input
                                    type="checkbox"
                                    className="checkboxDetail me-2 form-check-input"
                                    checked={o.isChecked}
                                    onChange={() => {
                                      const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                      setExpense(updatedData);
                                    }}
                                  />
                                </div>
                              </td>
                              <td className="text-center" style={{ verticalAlign: "middle" }}>
                                {o.transaction_no} {(o.hasPaid || o.paid_amount >= o.amount) && <span className="badge text-uppercase badge-soft-success mb-3">LUNAS</span>} {o.statusId === 4 && <span className="badge text-uppercase badge-soft-danger mb-3">CANCELED</span>}
                              </td>
                              <td className="text-center" style={{ verticalAlign: "middle" }}>
                                {handleValidDate(o.transactionat)}
                              </td>
                              <td className="text-center" style={{ verticalAlign: "middle" }}>
                                {type}
                              </td>
                              <td className="text-center" style={{ verticalAlign: "middle" }}>
                                {o?.at_cvl_account?.name || o?.at_cvl_contract?.cvl_contract_cvl_account?.name || (o?.at_purchase?.purchase_detail[0] && o?.at_purchase?.purchase_detail[0]?.cvl_account) || o?.at_tag?.name}
                              </td>
                              <td className="text-center" style={{ verticalAlign: "middle" }}>
                                {currencyFormat(o.amount)}
                              </td>
                              <td className="text-center" style={{ verticalAlign: "middle" }}>
                                {o.type === "PAYABLE" ? currencyFormat(o.paid_amount) : ""}
                              </td>
                              <td className="text-left" style={{ verticalAlign: "middle" }}>
                                {o.description}
                              </td>
                            </tr>
                          );
                        })}

                      {expense.length === 0 && (
                        <tr>
                          {" "}
                          <td colSpan="7" className="p-3 text-center">
                            {" "}
                            Belum ada realisasi
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </SimpleBar>
                <Row className="m-1 p-2 border border-top-0 border-end-0 border-start-0 bg-light">
                  <div className="col-sm-6 fs-12 text-start">
                    PAYABLE :<span className="ms-2 me-5 fs-20 fw-semibold text-end text-danger">{currencyFormat((expense.filter((el) => el.type === "PAYABLE" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)) || []).map((el) => parseFloat(el.amount || 0)).reduce((prev, curr) => prev + curr, 0))}</span>
                  </div>
                  <div className="col-sm-6 fs-12 text-end">
                    CASH OUT :<span className="ms-2 me-5 fs-20 fw-semibold text-end text-success">{currencyFormat((expense.filter((el) => el.type === "CASH OUT" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)) || []).map((el) => parseFloat(el.amount || 0)).reduce((prev, curr) => prev + curr, 0))}</span>
                  </div>
                </Row>
              </div>
            </CardBody>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModal(false);
                }}
              >
                TUTUP
              </button>
            </div>
          </div>
        </Modal>
        <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
            Invoice Detail
          </ModalHeader>
          {accTrans !== undefined && accTrans !== null ? (
            <ModalBody>
              <Row id="printThis">
                <Col lg={12}>
                  <CardHeader className="border-bottom-dashed p-4">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="80" />
                        <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="80" />
                        <div className="mt-sm-3 mt-3">
                          <h5 className="text-uppercase fw-semibold">{accTrans.at_client && accTrans.at_client.name}</h5>
                          <p className=" mb-1 text-uppercase fw-semibold">{accTrans.at_branch && accTrans.at_branch.name}</p>
                          <p className=" mb-1 text-uppercase">Department: {accTrans.at_department ? accTrans.at_department.name : "-"}</p>
                          <p className=" mb-1 text-uppercase">Anggaran: {accTrans.at_cvl_account ? accTrans.at_cvl_account.name : "-"}</p>
                          <p className=" mb-1 text-uppercase">Metode Bayar: {accTrans.at_pm ? accTrans.at_pm.name : "-"}</p>
                          <p className=" mb-1 text-uppercase">Tag: {accTrans.at_tag ? accTrans.at_tag.name : "-"}</p>
                        </div>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="p-4">
                    <Row className="g-3">
                      <Col lg={6} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">No Transaksi</p>
                        <h5 className="fs-14 mb-0">
                          #<span id="invoice-no">{accTrans.transaction_no}</span>
                        </h5>
                      </Col>
                      <Col lg={6} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">Date / Due Date</p>
                        <h5 className="fs-14 mb-0">
                          <span id="invoice-date">
                            {handleValidDate(accTrans.transactionat)} / {handleValidDate(accTrans.dueat)}
                          </span>
                        </h5>
                      </Col>
                      <Col lg={12} xs={12}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">Jumlah Pembayaran</p>
                        <h5 className="fs-18 mb-0">
                          <span id="total-amount">{currencyFormat(accTrans.amount)}</span>
                        </h5>
                      </Col>
                      <Col lg={12} xs={12}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">Terbilang</p>
                        <h5 className="fs-12 mb-0">
                          <span id="total-amount fs-14">{numberToWords(accTrans.amount)}</span>
                        </h5>
                      </Col>
                    </Row>
                  </CardBody>
                  {accTrans.at_purchase && accTrans.at_purchase.purchase_detail && (
                    <CardBody className="p-4">
                      <Table className="table-borderless text-center table-nowrap align-middle">
                        <thead>
                          <tr className="table-active">
                            <th scope="col" style={{ width: "50px" }}>
                              #
                            </th>
                            <th scope="col" className="text-start">
                              Detail Produk
                            </th>
                            <th scope="col" className="text-start">
                              Anggaran
                            </th>
                            <th scope="col">Harga</th>
                            <th scope="col">Jumlah</th>
                            <th scope="col">Penerimaan Barang</th>
                            <th scope="col" className="text-end">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody id="products-list">
                          {(accTrans.at_purchase.purchase_detail || []).map((o, i) => {
                            return (
                              <tr key={i} id={i} className="product">
                                <th scope="row" className="product-id">
                                  {i + 1}
                                </th>
                                <td className="text-start">{o.name}</td>
                                <td className="text-start">{o.cvl_account}</td>
                                <td>Rp{currencyFormat(o.amount)}</td>
                                <td>{currencyFormat(o.quantity)}</td>
                                <td>{o.accepted}</td>
                                <td className="text-end">Rp{currencyFormat(o.amount * o.quantity)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </CardBody>
                  )}
                  <CardBody className="p-4">
                    <div className="mt-0 mb-5">
                      <div className="alert alert-item bg-soft-accTrans">
                        <p className="mb-0">
                          <span className="fw-semibold fs-16">NOTES:</span>
                          <span id="note" className="fs-14">
                            {accTrans.description}
                          </span>
                        </p>
                      </div>
                    </div>
                    <Row className="g-3">
                      <Col lg={6} xs={6}>
                        <p className="mb-0 text-center">Bogor, {handleValidDate(accTrans.createdat)}</p>
                        <p className="mb-0 text-center">Pengajuan</p>
                        <p className="mb-5 pb-3 fw-semibold text-center">{accTrans.at_createdby ? accTrans.at_createdby.name : ""}</p>
                        <p className="mt-5 text-center">................................</p>
                      </Col>
                      <Col lg={6} xs={6}>
                        <p className="mb-0 text-center">{accTrans.approvedat && handleValidDate(accTrans.approvedat)}</p>
                        <p className="mb-0 text-center">Disetujui Oleh</p>
                        <p className="mb-5 pb-3 fw-semibold text-center">{accTrans.at_approvedby ? accTrans.at_approvedby.name : ""}</p>
                        <p className="mt-5 text-center">................................</p>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardBody className="p-4">
                    <Row className="g-3">
                      {(accTrans.at_file || []).map((f, i) => {
                        if (f.isDeleted) {
                          return null;
                        } else {
                          return (
                            <Col lg={3} xs={3} key={i}>
                              {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                              ) : (
                                <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                  <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                </Link>
                              )}
                            </Col>
                          );
                        }
                      })}
                    </Row>
                  </CardBody>
                </Col>
              </Row>
            </ModalBody>
          ) : null}
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  toggleDetail();
                }}
              >
                {" "}
                Close
              </button>
            </div>
          </div>
        </Modal>

        <Modal id="showModal" isOpen={modalMaterial} centered size="xl">
          <ModalHeader className="bg-light p-3" toggleMaterial={toggleMaterial}>
            DETAIL REALISASI ANGGARAN {label}
          </ModalHeader>
          <ModalBody>
            <CardBody>
              <div>
                <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                  <div className="col-sm-10">
                    <Row className="m-0 p-0 ">
                      <div className="fw-semibold col-sm-5 text-start">
                        <input className="search-box  w-100 form-control" placeholder="Filter Material / Supplier" onChange={(e) => searchList(e.target.value)} />
                      </div>
                    </Row>
                  </div>
                  <div className="col-sm-2 text-end">
                    <ExportDoc data={printDetailDoc} />
                  </div>
                </Row>
                <SimpleBar style={{ height: "380px" }}>
                  <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                    <thead className="align-middle">
                      <tr className="table-active">
                        <td style={{ width: "20px" }}>
                          <input
                            type="checkbox"
                            className="checkboxDetailAll me-2 form-check-input"
                            checked={expense.every((item) => item.isChecked)}
                            onChange={() => {
                              const allChecked = expense.every((item) => item.isChecked);
                              const updatedData = expense.map((item) => ({
                                ...item,
                                isChecked: !allChecked,
                              }));
                              setExpense(updatedData);
                            }}
                          />
                        </td>
                        <td>Pembelian</td>
                        <td className="text-center" style={{ width: "170px" }}>
                          No Transaksi
                        </td>
                        <td className="text-center" style={{ width: "170px" }}>
                          Tanggal
                        </td>
                        <td className="text-center" style={{ width: "170px" }}>
                          Harga
                        </td>
                        <td className="text-center" style={{ width: "170px" }}>
                          Jumlah
                        </td>
                        <td className="text-center" style={{ width: "170px" }}>
                          Terima
                        </td>
                        <td className="text-center" style={{ width: "150px" }}>
                          Total
                        </td>
                      </tr>
                    </thead>
                    <tbody id="newlink">
                      {(expense || []).map((o, i) => {
                        return (
                          <tr key={i} id={i} className="product">
                            <td className="product-id">
                              <input
                                type="checkbox"
                                className="checkboxDetail me-2 form-check-input"
                                checked={o.isChecked}
                                onChange={() => {
                                  const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                  setExpense(updatedData);
                                }}
                              />{" "}
                              {i + 1}
                            </td>
                            <td className="text-start">
                              {o.name} {o.description}
                            </td>
                            <td className="text-center">{o.transaction_no}</td>
                            <td className="text-center">{handleValidDate(o.transactionat)}</td>
                            <td className="text-center">{currencyFormat(parseFloat(o.amount))}</td>
                            <td className="text-center">{parseFloat(o.quantity ?? 0)}</td>
                            <td className="text-center">{parseFloat(o.accepted ?? 0)}</td>
                            <td className="text-center fw-semibold">{currencyFormat(parseFloat(o.quantity) * parseFloat(o.amount))}</td>
                          </tr>
                        );
                      })}
                      {expense.length === 0 && (
                        <tr>
                          <td colSpan="7" className="p-3 text-center">
                            Belum ada realisasi
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </SimpleBar>
              </div>
            </CardBody>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModalMaterial(false);
                }}
              >
                TUTUP
              </button>
            </div>
          </div>
        </Modal>
      </Container>
    </div>
  );
};
export default CivilBudget;
